import React from 'react'
import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'

const FilterActions = ({ primaryLabel, primaryAction, secondaryLabel, secondaryAction, expanded, disabled }) => (
	<CardActions
		style={{
			display: 'flex',
			justifyContent: 'flex-end',
			backgroundColor: '#f1f1f1',
		}}
	>
		<Button variant="text" onClick={secondaryAction} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
			{secondaryLabel}
		</Button>
		<Button variant="text" color='primary' onClick={primaryAction} disabled={disabled} style={{ color: '#0e5777' }}>
			{primaryLabel}
		</Button>
	</CardActions>
)

export default FilterActions
